module.exports = __webpack_public_path__ + "img/family-tree-03.20174d67.png";